var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "orderDetailProduct"
  }, [_c("div", {
    staticClass: "modular"
  }, [_c("h3", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.productTitle")))]), _c("div", {
    staticClass: "productList"
  }, [_c("div", {
    staticClass: "orderChannel"
  }, [_c("div", {
    staticStyle: {
      flex: "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("orderDetailProduct.expressNo")) + "：" + _vm._s(_vm.productInfo.orderNo) + " "), _c("a-tag", {
    staticClass: "orderStatus",
    attrs: {
      color: "blue"
    }
  }, [_vm._v(" " + _vm._s(_vm.productInfo.orderStatus == 1 ? _vm.$t("public.orderStatus5") : _vm.productInfo.orderStatus == 2 ? _vm.$t("public.orderStatus7") : _vm.$t("public.orderStatus9")) + " ")])], 1), _c("div", {
    staticStyle: {
      flex: "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("orderDetail2.arriveDate")) + "：" + _vm._s(_vm.productInfo.arriveDate) + " " + _vm._s(_vm.productInfo.arriveTimeStr || "")), _c("br")])]), _vm._l(_vm.productInfo.transportList, function (temperature) {
    return [temperature.transportName ? _c("div", {
      staticClass: "temperature"
    }, [_c("div", {
      staticStyle: {
        display: "flex"
      }
    }, [_c("span", {
      staticStyle: {
        "font-weight": "800",
        "font-size": "14px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("orderDetailProduct.transportName")) + "：" + _vm._s(temperature.transportName))]), temperature.cashOnDeliveryInfoList && temperature.cashOnDeliveryInfoList.length > 0 ? [temperature.cashOnDeliveryAmount ? _c("span", {
      staticStyle: {
        "margin-left": "auto"
      }
    }, [_vm._v(_vm._s(_vm.$t("orderDetail2.bundleAgent") + "："))]) : _vm._e(), _c("a", {
      style: temperature.cashOnDeliveryAmount ? "" : "margin-left:auto",
      on: {
        click: function click($event) {
          return _vm.goAgentAmount(temperature.cashOnDeliveryInfoList, temperature.cashOnDeliveryAmount);
        }
      }
    }, [_vm._v(_vm._s(temperature.cashOnDeliveryAmount ? _vm.formatMoney(temperature.cashOnDeliveryAmount) : _vm.$t("orderDetail2.bundleAgentson")))])] : _vm._e()], 2)]) : _vm._e(), _c("a-table", {
      attrs: {
        pagination: false,
        bordered: "",
        rowKey: temperature.productNo,
        columns: _vm.columns,
        "data-source": temperature.productList
      },
      scopedSlots: _vm._u([{
        key: "productName",
        fn: function fn(text, record) {
          return _c("span", {}, [record.normalProduct == 1 && record.productType == 0 ? _c("router-link", {
            attrs: {
              target: "_blank",
              to: {
                path: "/productmanager/productDetail",
                query: {
                  id: record.productId
                }
              }
            }
          }, [_vm._v(_vm._s(record.productName + "  " + record.productSpecification))]) : _c("span", [_vm._v(_vm._s(record.productName + "  " + record.productSpecification))]), record.normalProduct == 1 ? _c("span", [_c("br"), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.chineseName")) + "：" + _vm._s((record.traditionalProductName ? record.traditionalProductName : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.rongliang")) + "：" + _vm._s((record.capacity ? record.capacity : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.rushu")) + "：" + _vm._s((record.caseQuantity ? record.caseQuantity : "--") + "   "))]), _c("span", [_vm._v(_vm._s("JAN") + "：" + _vm._s((record.janCode ? record.janCode : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.brand")) + "：" + _vm._s((record.productBrand ? record.productBrand : "--") + "   "))]), _c("span", [_vm._v(_vm._s(_vm.$t("orderDetailProduct.source")) + "：" + _vm._s((record.productSourcearea ? record.productSourcearea : "--") + "   "))])]) : _vm._e()], 1);
        }
      }, {
        key: "productNum",
        fn: function fn(text, record) {
          return _c("span", {}, [record.normalProduct > 0 ? _c("span", [_vm._v(_vm._s(record.productNum) + _vm._s(record.doWeight === 0 ? record.productUnit : ""))]) : _c("span", [_vm._v("--")])]);
        }
      }, {
        key: "sellWay",
        fn: function fn(text, record) {
          return _c("span", {}, [record.normalProduct > 0 && record.doWeight == 1 ? _c("span", [_vm._v(_vm._s(record.caseOrItem == 1 ? _vm.$t("orderDetail2.totalBox") : _vm.$t("orderDetail2.sanBox")))]) : _c("span", [_vm._v("--")])]);
        }
      }, {
        key: "salePrice",
        fn: function fn(text, record) {
          return _c("span", {}, [record.normalProduct > 0 ? _c("span", [_vm._v(_vm._s(_vm.formatMoney(record.salePrice, "0")))]) : _c("span", [_vm._v("--")])]);
        }
      }, {
        key: "productSubTotal",
        fn: function fn(text, record) {
          return _c("span", {}, [record.productSubTotal ? _c("span", [_vm._v(" " + _vm._s(_vm.formatMoney(record.productSubTotal, "0")))]) : _c("span", [_vm._v("--")])]);
        }
      }, {
        key: "taxAmount",
        fn: function fn(text, record) {
          return _c("span", {}, [record.taxAmount ? _c("span", [_vm._v(" " + _vm._s(_vm.formatMoney(record.taxAmount, "0")))]) : _c("span", [_vm._v("--")])]);
        }
      }], null, true)
    }, [_c("template", {
      slot: "footer"
    }, [_c("div", {
      staticClass: "ant-table-body"
    }, [_c("table", [_c("tbody", {
      staticClass: "ant-table-tbody"
    }, [_c("tr", [_c("td", {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        colspan: "6"
      }
    }, [_vm._v(_vm._s(_vm.$t("orderDetailProduct.totalAmountAndTax") + (_vm.productInfo.taxList ? _vm.$t("orderDetail2.suiru") : _vm.$t("orderDetail2.suiba"))))]), _c("td", {
      staticStyle: {
        width: "120px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatMoney(_vm.productInfo.totalAmount)))])]), _c("tr", [_c("td", {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        colspan: "6"
      }
    }, [_vm._v(_vm._s(_vm.$t("orderDetailProduct.totalTax")))]), _c("td", {
      staticStyle: {
        width: "120px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatMoney(_vm.taxTotal)))])]), _c("tr", [_c("td", {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        colspan: "6"
      }
    }, [_vm._v(_vm._s(_vm.$t("orderDetailProduct.totalTax8")))]), _c("td", {
      staticStyle: {
        width: "120px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatMoney(_vm.tax8)))])]), _c("tr", [_c("td", {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        colspan: "6"
      }
    }, [_vm._v(_vm._s(_vm.$t("orderDetailProduct.totalTax10")))]), _c("td", {
      staticStyle: {
        width: "120px",
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formatMoney(_vm.tax10)))])])])])])])], 2)];
  })], 2)]), _c("a-modal", {
    attrs: {
      title: _vm.agentTitle,
      visible: _vm.agentVisible,
      footer: null,
      rowKey: "expressNo"
    },
    on: {
      cancel: function cancel() {
        return _vm.agentVisible = false;
      }
    }
  }, [_c("a-table", {
    attrs: {
      footer: null,
      pagination: false,
      columns: _vm.columnsAgent,
      "data-source": _vm.agentData
    },
    scopedSlots: _vm._u([{
      key: "expressNo",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("router-link", {
          attrs: {
            target: "_blank",
            to: {
              path: "/orderDetail2",
              query: {
                id: record.id
              }
            }
          }
        }, [_vm._v(_vm._s(record.erpOrderNo))])], 1);
      }
    }, {
      key: "expressNoAmount",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(_vm.formatMoney(record.erpOrderAmount)) + " ")]);
      }
    }, {
      key: "deliveryAmount",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(_vm.formatMoney(record.deliveryAmount)) + " ")]);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };